
import { defineComponent } from 'vue'
import NewElectronicOperator from '@/components/electronic-operators/forms/new-electronic-operator.vue'

export default defineComponent({
    name: 'view-electronic-operators-new',
    components: { NewElectronicOperator }
})
